export const getSeleccionado = (array, key = "seleccionado") => {
  return array.find(item => item[key])
}